// extracted by mini-css-extract-plugin
export default {"LandingPage":"landing-page_LandingPage__C1Ote"};